/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const CurriculumIcon = /*#__PURE__*/ createSvgIcon(
  'CurriculumIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M8.75 11.5h2.5c.213 0 .39-.072.534-.214a.72.72 0 00.216-.532.734.734 0 00-.216-.535.72.72 0 00-.534-.219h-2.5a.728.728 0 00-.534.214.72.72 0 00-.216.532c0 .21.072.39.216.535a.72.72 0 00.534.219zm0-2.5h5.5c.213 0 .39-.071.534-.214A.72.72 0 0015 8.254a.734.734 0 00-.216-.535.72.72 0 00-.534-.219h-5.5a.728.728 0 00-.534.214.72.72 0 00-.216.532c0 .21.072.39.216.535A.72.72 0 008.75 9zm0-2.5h5.5c.213 0 .39-.071.534-.214A.72.72 0 0015 5.754a.734.734 0 00-.216-.535A.72.72 0 0014.25 5h-5.5a.728.728 0 00-.534.214.72.72 0 00-.216.532c0 .21.072.39.216.535a.72.72 0 00.534.219zM6.5 15c-.412 0-.766-.147-1.06-.44A1.445 1.445 0 015 13.5v-10c0-.413.147-.766.44-1.06.294-.293.647-.44 1.06-.44h10c.413 0 .766.147 1.06.44.293.294.44.647.44 1.06v10c0 .412-.147.766-.44 1.06-.294.293-.647.44-1.06.44h-10zm0-1.5h10v-10h-10v10zm-3 4.5c-.413 0-.766-.147-1.06-.44A1.445 1.445 0 012 16.5V5.75c0-.213.071-.39.214-.534A.72.72 0 012.746 5c.21 0 .39.072.535.216a.72.72 0 01.219.534V16.5h10.75c.213 0 .39.072.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219H3.5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default CurriculumIcon;
